import { createContext, Dispatch, SetStateAction, useMemo, useState } from 'react';

import type { AuthorizationData, RegistrationData } from './types';

import { AUTH_DATA_INITIAL_STATE, REG_DATA_INITIAL_STATE } from './constants';

// ---

type AuthContextData = {
  authData: AuthorizationData;
  setAuthData: Dispatch<SetStateAction<AuthorizationData>>;
};

const authContextDefaultValue: AuthContextData = {
  authData: AUTH_DATA_INITIAL_STATE,
  setAuthData: () => null,
};

export const AuthContext = createContext<AuthContextData>(authContextDefaultValue);

export const useAuthContextValue = (): AuthContextData => {
  const [authData, setAuthData] = useState<AuthorizationData>(AUTH_DATA_INITIAL_STATE);

  return useMemo(() => ({ authData, setAuthData }), [authData]);
};

// ---

type RegContextData = {
  regData: RegistrationData;
  setRegData: Dispatch<SetStateAction<RegistrationData>>;
};

const regContextDefaultValue: RegContextData = {
  regData: REG_DATA_INITIAL_STATE,
  setRegData: () => null,
};

export const RegContext = createContext<RegContextData>(regContextDefaultValue);

export const useRegContextValue = (): RegContextData => {
  const [regData, setRegData] = useState<RegistrationData>(REG_DATA_INITIAL_STATE);

  return useMemo(() => ({ regData, setRegData }), [regData]);
};
